const STATUS_LABELS = {
  OPN: "Open",
  INP: "In Progress",
  CRS: "Resolved",
  CNR: "No Response",
}

const isEmpty = (value) =>
  value === undefined ||
  value === null ||
  (typeof value === "string" && value.trim() === "")

export const toSafeValue = (value, fallback = "-") => {
  if (isEmpty(value)) return fallback
  return typeof value === "string" ? value.trim() : value
}

export const trimTextValue = (value, maxLength = 120, fallback = "-") => {
  const safeValue = toSafeValue(value, fallback)
  if (safeValue === fallback) return fallback

  const normalized = String(safeValue)
  return normalized.length > maxLength
    ? `${normalized.slice(0, maxLength).trimEnd()}...`
    : normalized
}

export const getInquiryStatusCode = (value) => {
  const normalized = String(value || "").trim().toUpperCase()
  return normalized || ""
}

export const getInquiryStatusLabel = (value, fallback = "-") => {
  const statusCode = getInquiryStatusCode(value)
  return STATUS_LABELS[statusCode] || toSafeValue(statusCode, fallback)
}

export const formatDateInputValue = (value) => {
  if (isEmpty(value)) return ""

  const normalized = String(value).trim()
  if (/^\d{4}-\d{2}-\d{2}$/.test(normalized)) return normalized

  const dateMatch = normalized.match(/^(\d{4}-\d{2}-\d{2})[ T]/)
  if (dateMatch) return dateMatch[1]

  const parsedDate = new Date(normalized)
  if (Number.isNaN(parsedDate.getTime())) return ""

  const year = parsedDate.getFullYear()
  const month = String(parsedDate.getMonth() + 1).padStart(2, "0")
  const day = String(parsedDate.getDate()).padStart(2, "0")
  return `${year}-${month}-${day}`
}

export const mapInquiryToUi = (inquiry = {}, options = {}) => {
  const {
    detailsMaxLength = 140,
    remarksMaxLength = 140,
  } = options

  const statusCode = getInquiryStatusCode(
    inquiry?.status_code ?? inquiry?.status ?? inquiry?.statusCode
  )
  const nextFollowupRaw =
    inquiry?.Next_followup ?? inquiry?.next_followup ?? inquiry?.nextFollowup ?? ""
  const detailsRaw =
    inquiry?.other_query ?? inquiry?.details ?? inquiry?.description ?? ""
  const remarksRaw =
    inquiry?.agent_remarks ??
    inquiry?.agentRemarks ??
    inquiry?.remarks ??
    inquiry?.Description ??
    inquiry?.description ??
    ""
  const inquiryTypeRaw =
    inquiry?.last_question_text ??
    inquiry?.inquiry_type ??
    inquiry?.last_question ??
    inquiry?.lastQuestion ??
    ""

  return {
    ...inquiry,
    id: inquiry?.id ?? inquiry?.ticket_id ?? inquiry?.ticketId ?? "-",
    client: toSafeValue(
      inquiry?.Client_name ?? inquiry?.client ?? inquiry?.client_name ?? inquiry?.clientName
    ),
    contact: toSafeValue(inquiry?.contact ?? inquiry?.phone ?? inquiry?.mobile),
    email: toSafeValue(inquiry?.email ?? inquiry?.Email),
    details: trimTextValue(detailsRaw, detailsMaxLength),
    details_full: toSafeValue(detailsRaw),
    remarks: trimTextValue(remarksRaw, remarksMaxLength),
    remarks_full: toSafeValue(remarksRaw),
    next_followup: toSafeValue(nextFollowupRaw),
    next_followup_raw: isEmpty(nextFollowupRaw) ? "" : String(nextFollowupRaw).trim(),
    next_followup_value: formatDateInputValue(nextFollowupRaw),
    inquiry_type: toSafeValue(inquiryTypeRaw),
    inquiry_type_full: toSafeValue(inquiryTypeRaw),
    status: getInquiryStatusLabel(statusCode),
    status_code: statusCode,
    created_at: toSafeValue(
      inquiry?.created_at ?? inquiry?.createdAt ?? inquiry?.created
    ),
    assigned_to:
      inquiry?.assigned_to === "" || inquiry?.assigned_to === undefined
        ? null
        : inquiry?.assigned_to ?? inquiry?.assignedTo ?? null,
  }
}

export const mapInquiryListToUi = (inquiries = [], options = {}) =>
  Array.isArray(inquiries)
    ? inquiries.map((inquiry) => mapInquiryToUi(inquiry, options))
    : []

export const INQUIRY_STATUS_LABELS = STATUS_LABELS
